import { Typography, useTheme } from '@mui/material';

type Props = {
  text: string;
  fontSize?: string;
  padding?: string;
};

export const StateLabelBox = ({ text, fontSize, padding }: Props) => {
  const theme = useTheme();

  const isOpened = text.toLowerCase() === 'opened';
  const isError = text.toLowerCase() === 'error';

  return (
    <Typography
      sx={{
        color: isOpened
          ? theme.palette.primary.main
          : isError
          ? theme.palette.error.main
          : theme.palette.grey[800],
        background: isOpened
          ? theme.palette.primary.lighter
          : isError
          ? theme.palette.error.lighter
          : theme.palette.grey[300],
        borderRadius: '6px',
        fontFamily: 'Public Sans',
        fontWeight: 700,
        fontSize: fontSize ? fontSize : '14px',
        lineHeight: '24px',
        padding: padding ? padding : '6px 8px',
        textAlign: 'center',
      }}
      data-sm={text}
    >
      {text}
    </Typography>
  );
};
